import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../components/css/fixed.css";
import logoImage from "../assets/imgs/logo_bg_removed.png";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTimes } from "react-icons/fa";
import { MdPhone, MdEmail } from "react-icons/md";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [hoveredLink, setHoveredLink] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 0;
      if (scrolled !== isScrolled) {
        setIsScrolled(scrolled);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isScrolled]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.style.overflow = !isOpen ? 'hidden' : 'unset';
  };

  const closeMenu = () => {
    setIsOpen(false);
    document.body.style.overflow = 'unset';
  };

  const handleLinkClick = (path, e) => {
    e.preventDefault();
    navigate(path);
    closeMenu();
  };

  const isActiveLink = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''} ${isOpen ? 'menu-open' : ''}`}>
        <div className="navbar-container">
          <div 
            className="logo" 
            onClick={(e) => handleLinkClick('/', e)} 
            style={{ cursor: 'pointer' }}
          >
            <img 
              src={logoImage} 
              alt="Rhythmgrowthlab Logo" 
              className="logo-image"
            />
          </div>

          {/* Desktop Navigation */}
          <ul className="nav-links">
            {[
              { path: '/', label: 'Home' },
              { path: '/services-and-pricing', label: 'Our Services & Pricings' },
              { path: '/our-portfolio', label: 'Our Portfolio' },
              { path: '/agency-account', label: 'Agency Account' },
              { path: '/contact-us', label: 'Contact Us Now!!', isButton: true }
            ].map((item, index) => (
              <li 
                key={item.path}
                onMouseEnter={() => setHoveredLink(item.path)}
                onMouseLeave={() => setHoveredLink(null)}
              >
                <a 
                  href={item.path}
                  className={
                    item.isButton 
                      ? `contact-btn ${isActiveLink(item.path) ? 'active' : ''}`
                      : isActiveLink(item.path) ? 'active' : ''
                  }
                  onClick={(e) => handleLinkClick(item.path, e)}
                >
                  {item.label}
                  {!item.isButton && hoveredLink === item.path && (
                    <span className="link-hover-effect"></span>
                  )}
                </a>
              </li>
            ))}
          </ul>

          {/* Mobile Menu */}
          <div className={`menu-toggle ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <div className="hamburger-lines">
              <span className="hamburger-line line1"></span>
              <span className="hamburger-line line2"></span>
              <span className="hamburger-line line3"></span>
            </div>
          </div>
        </div>
      </nav>

      <div 
        className={`mobile-menu-overlay ${isOpen ? 'active' : ''}`} 
        onClick={closeMenu}
      ></div>
      
      <div className={`mobile-menu ${isOpen ? 'active' : ''}`}>
        <div className="mobile-menu-header">
          <img 
            src={logoImage} 
            alt="Rhythmgrowthlab Logo" 
            className="mobile-logo" 
            onClick={(e) => handleLinkClick('/', e)}
            style={{ cursor: 'pointer' }}
          />
          <button className="close-menu-btn" onClick={closeMenu}>
            <FaTimes />
          </button>
        </div>
        
        <ul className="mobile-nav-links">
          {[
            { path: '/', label: 'Home' },
            { path: '/services-and-pricing', label: 'Our Services & Pricings' },
            { path: '/our-portfolio', label: 'Our Portfolio' },
            { path: '/agency-account', label: 'Agency Account' },
            { path: '/contact-us', label: 'Contact Us Now!!', isButton: true }
          ].map((item, index) => (
            <li key={item.path}>
              <a 
                href={item.path}
                className={
                  item.isButton 
                    ? `mobile-contact-btn ${isActiveLink(item.path) ? 'active' : ''}`
                    : isActiveLink(item.path) ? 'active' : ''
                }
                onClick={(e) => handleLinkClick(item.path, e)}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="mobile-menu-footer">
          <div className="contact-details">
            <h4>Contact Us</h4>
            <div className="contact-item">
              <MdPhone className="contact-icon" />
              <a href="tel:+919582795505" className="contact-link">
                +91-9582795505
              </a>
            </div>
            <div className="contact-item">
              <MdEmail className="contact-icon" />
              <a href="mailto:rhythmgrowthlab@gmail.com" className="contact-link">
                rhythmgrowthlab@gmail.com
              </a>
            </div>
          </div>

          <div className="social-icons">
            <h4>Follow Us</h4>
            <div className="social-icons-grid">
              <a 
                href="https://www.instagram.com/rhythmgrowthlab" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon"
              >
                <FaInstagram />
              </a>
              <a 
                href="https://www.facebook.com/people/Rhythmgrowthlab/61587331876796/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon"
              >
                <FaFacebookF />
              </a>
              <a 
                href="https://www.linkedin.com/company/rhythmgrowthlab" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon"
              >
                <FaLinkedinIn />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;